import React from "react";

import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";

import HomeIcon from "@material-ui/icons/Home";
import FolderIcon from "@material-ui/icons/Folder";

import Button from "@material-ui/core/Button";

import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CreateNewFolderIcon from "@material-ui/icons/CreateNewFolder";

class Header extends React.Component {
  onBreadcrumbClick(folder) {
    const onBreadcrumbClick = this.props.onBreadcrumbClick || null;
    if (onBreadcrumbClick) {
      return onBreadcrumbClick(folder);
    }
  }

  onCreateFolderClick(e) {
    const onCreateFolderClick = this.props.onCreateFolderClick || null;
    if (onCreateFolderClick) {
      return onCreateFolderClick();
    }
  }

  onUploadClick(e) {
    const onUploadClick = this.props.onUploadClick || null;
    if (onUploadClick) {
      return onUploadClick();
    }
  }

  render() {
    const { breadcrumbs, hasUpload, hasCreateFolder } = this.props;

    return (
      <div className="zee-explorer-header">
        <div className="breadcrumbs">
          <Breadcrumbs aria-label="breadcrumb">
            {breadcrumbs.map((folder) => (
              <Link
                color="inherit"
                onClick={() => this.onBreadcrumbClick(folder)}
              >
                {folder.id === 0 ? <HomeIcon /> : <FolderIcon />}
                {folder.name}
              </Link>
            ))}
          </Breadcrumbs>
        </div>

        <div className="actions">
          {hasUpload && (
            <Button
              variant="contained"
              size="small"
              color="secondary"
              startIcon={<CloudUploadIcon />}
              onClick={(e) => this.onUploadClick(e)}
            >
              Upload
            </Button>
          )}

          {hasCreateFolder && (
            <Button
              variant="contained"
              size="small"
              color="secondary"
              startIcon={<CreateNewFolderIcon />}
              onClick={(e) => this.onCreateFolderClick(e)}
            >
              Create folder
            </Button>
          )}
        </div>
      </div>
    );
  }
}

export default Header;
